import keyMirror from '../../../utils/keyMirror';

export default keyMirror({
    SET_TRACK_OPTIONS: null,
    SET_SELECTED_TRACK_ITEMS: null,
    SET_CLIC_NUMS: null
});